import {SyncEventType} from '../../enums/syncEventType';
import {RealtimeEvent} from './realtimeEvent';

/**
 * Event to notify that the extended data (attachments, comments) of the underlying issue has been updated
 */
export class EventIssuecardUpdatedExt implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_UPDATED_EXT;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardUpdatedExt {
    return new EventIssuecardUpdatedExt(
      payload['issueId'], payload['avatar']
    );
  }

}

